export default __webpack_public_path__ + "static/media/B3_31.d217e8cd.mp3";